export default {
    INIT_GROUP_DATA: 'initGroupData',
    SET_STATEMENT_FILES: 'setStatementFiles',
    REFRESH_TITLE: 'refreshTitle',
    UPDATE_GROUP_DATA_WITH_EXISTING_OPERATION: 'updateGroupDataWithExistingOperation',
    UPDATE_GROUP_STATE: 'updateGroupData',
    INIT_MODAL_CHECKBOXES: 'initModalCheckboxes',
    INIT_MODAL_CONTENT : 'initModalContent',
    SET_MODAL_DOCUMENT_CHECKBOX: 'setModalDocumentCheckbox',
    CLEAR_MODAL_DOCUMENTS_CHECKBOXES: 'clearModalDocumentsCheckboxes',
    SET_MODAL_DEPARTMENT_CHECKBOXES: 'setModalDepartmentCheckboxes',
    ADD_OPERATION: 'addOperation',
    ADD_OPERATION_TO_GROUP: 'addOperationToGroup',
    DELETE_OPERATION: "deleteOperation",
    SET_STATE_TO_COMMIT_ALLOCATIONS: 'setStateToCommitAllocations',
    SET_STATE_TO_COMMIT_OPERATION: 'setStateToCommitOperation',
    CLEAR_STATE_TO_COMMIT_OPERATION: 'clearStateToCommitOperation',
    SET_STATE_LEFT_FOR_SPLIT: 'setStateLeftToSplit',
    UPDATE_OPERATION: 'updateOperation',
    CLEAR_STATE_TO_COMMIT_ALLOCATIONS: 'clearStateToCommitAllocations',
    UPDATE_STATE_TO_COMMIT: 'updateStateToCommit',
    UPDATE_DOCUMENT_ALLOCATIONS: 'updateDocumentAllocations',
    UPDATE_PROFORMA_ALLOCATIONS: 'updateProformaAllocations',
    CLEAR_DOCUMENT_ALLOCATIONS: 'clearDocumentAllocations',
    UPDATE_DEPARTMENT_ALLOCATIONS: 'updateDepartmentAllocations',
    EXCHANGE_ELEMENTS: 'exchangeElements',
    SORT_GROUPS: 'sortGroups',
    DYNAMIC_UPDATE_DOCUMENT_BALANCE: "dynamicUpdateDocumentBalance",
    CLEAR_PAYMENTS_STATE: 'clearPaymentsState',
    SET_DEPARTMENT:'setDepartments',
    SET_GROUP_DATA:'setGroupData',
}
